/* eslint-disable @typescript-eslint/no-unused-vars */
/* eslint-disable class-methods-use-this */
import AppError from '../errors/AppError';
import api from './api';
import { getToken } from './auth';

type Installment = {
  idParcela: string;
  dataVencimentoParcela: string;
  dataPagamentoParcela: string | null;
  pago: boolean;
  urlBoleto: string;
  valor: number;
}

type Sale = {
  idVenda: string;
  status: string;
  pagamentoLiberado: boolean;
  installments: Installment[];
}

export interface IProposalWeBroPayInfo {
  nomeCliente: string;
  nomeRecebedor: string;
  documentoRecebedor: string;
  valorTotal: number;
  sales: Sale[]
}

interface IGenerateCustomWeBroPayCommissionSaleInvoice {
  idProposalApp: string;
  receiverDocument: string;
  totalCommissionValue: number;
  commissionInstallmentAmount: number;
  firstInstallmentDate: string;
}

class CommissionSalesService {
  private headers: any;

  constructor() {
    this.headers = {
      Authorization: `Bearer: ${getToken()}`, "ngrok-skip-browser-warning": "bairru", "ngrok-skip-browser-warning": "bairru",
    };
  }

  public async getWebropaySales(cod_mega: string | number) {
    try {
      const { data } = await api.get<{ weBroPaySales: IProposalWeBroPayInfo }>(`/commissionSales/webropay_sales`, {
        params: {
          codMega: cod_mega
        },
        headers: {
          Authorization: `Bearer: ${getToken()}`, "ngrok-skip-browser-warning": "bairru", "ngrok-skip-browser-warning": "bairru",
        },
      });

      if (!data.weBroPaySales || !data.weBroPaySales.sales || Object.keys(data.weBroPaySales).length === 0) {
        return {
          weBroPaySales: null
        };
      }

      return data;
    } catch (err: any) {
      return {
        weBroPaySales: null
      };
    }
  }

  public async unlockCommissionSales(id: string) {
    try {
      const { data } = await api.patch(`/commissionSales/webropay_sales/unlock/${id}`, {
      }, {
        headers: {
          Authorization: `Bearer: ${getToken()}`, "ngrok-skip-browser-warning": "bairru", "ngrok-skip-browser-warning": "bairru",
        },
      });
      return data;
    } catch (err: any) {
      throw new AppError('Não foi possível liberar a comissão', 403);
    }
  }

  public async lockCommissionSales(id: string) {
    try {
      const { data } = await api.patch(`/commissionSales/webropay_sales/lock/${id}`, {
      }, {
        headers: {
          Authorization: `Bearer: ${getToken()}`, "ngrok-skip-browser-warning": "bairru", "ngrok-skip-browser-warning": "bairru",
        },
      });
      return data;
    } catch (err: any) {
      throw new AppError('Não foi possível bloquear a comissão', 403);
    }
  }

  public async generateSecondCopyCommissionSales(idVenda: string, idParcela: string, newDueDate: string) {
    try {
      const { data } = await api.patch(`/commissionSales/webropay_sales/second_copy`, {
        idVenda,
        idParcela,
        newDueDate,
      }, {
        headers: {
          Authorization: `Bearer: ${getToken()}`, "ngrok-skip-browser-warning": "bairru", "ngrok-skip-browser-warning": "bairru",
        },
      });
      return data;
    } catch (err: any) {
      throw new AppError('Não foi possível gerar a 2° via de comissão', 403);
    }
  }

  public async deleteWeBroPayCommissionSalesByCodMega(codMega: string) {
    try {
      const { data } = await api.delete(`/commissionSales/webropay_sales/cod_mega/${codMega}`, {
        headers: {
          Authorization: `Bearer: ${getToken()}`, "ngrok-skip-browser-warning": "bairru", "ngrok-skip-browser-warning": "bairru",
        },
      });
      return data;
    } catch (err: any) {
      throw new AppError('Não foi possível deletar a comissão', 403);
    }
  }

  public async generateCustomWeBroPayCommissionSaleInvoice({ idProposalApp, receiverDocument, totalCommissionValue, commissionInstallmentAmount, firstInstallmentDate }: IGenerateCustomWeBroPayCommissionSaleInvoice) {
    try {
      const { data } = await api.post(`/commissionSales/webropay_sales/custom`, {
        idProposalApp,
        receiverDocument,
        totalCommissionValue,
        commissionInstallmentAmount,
        firstInstallmentDate,
      }, {
        headers: {
          Authorization: `Bearer: ${getToken()}`, "ngrok-skip-browser-warning": "bairru", "ngrok-skip-browser-warning": "bairru",
        },
      });
      return data;
    } catch (err: any) {
      throw new AppError('Não foi possível gerar novas condições da comissão', 403);
    }
  }
}

export default new CommissionSalesService();

